'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n  align-items: center;  \n  border: none;\n  background-color: #fff;\n  box-shadow: ', '\n  padding: ', ';\n  margin: ', '\n  height: ', ';\n  width: ', ';\n'], ['\n  display: flex;\n  justify-content: center;\n  align-items: center;  \n  border: none;\n  background-color: #fff;\n  box-shadow: ', '\n  padding: ', ';\n  margin: ', '\n  height: ', ';\n  width: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ArrowWrapper = _styledComponents2.default.button(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return theme.smallShadow;
}, (0, _polished.rem)(5), (0, _polished.rem)(10), (0, _polished.rem)(20), (0, _polished.rem)(20));

function Arrow(props) {
  return _react2.default.createElement(ArrowWrapper, props, _react2.default.createElement(_Icon2.default, {
    size: 'xs',
    name: props.name
  }));
}

Arrow.propTypes = {
  name: _propTypes2.default.string.isRequired
};
exports.default = Arrow;
Arrow.__docgenInfo = [{
  'description': '',
  'displayName': 'Arrow',
  'methods': [],
  'props': {
    'name': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': ''
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/Arrow/index.js'] = {
    name: 'Arrow',
    docgenInfo: Arrow.__docgenInfo,
    path: 'src/Arrow/index.js'
  };
}